import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

export const PauseItem = ({
  title,
  interval_reference,
  trigger_interval,
  startTime,
  endTime,
  duration
}) => {
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  const startMoment = moment(startTime, 'HH:mm');
  const endMoment = moment(endTime, 'HH:mm');

  let time;
  if (interval_reference === 'ENTRY') {
    time = startMoment.add(trigger_interval, 'minutes').format('HH:mm');
  } else if (interval_reference === 'EXIT') {
    time = endMoment.subtract(trigger_interval, 'minutes').format('HH:mm');
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        padding: '4px 0'
      }}
    >
      <div
        style={{
          width: '10px',
          height: '10px',
          borderRadius: '50%',
          marginRight: '4px',
          backgroundColor: systemConfiguration.primary_color
        }}
      />
      <span
        style={{
          fontSize: '18px',
          color: '#8891A7'
        }}
      >
        {time}
      </span>
      <span style={{ fontSize: '18px', fontWeight: '600', color: '#8891A7' }}>
        {title} 
      </span>
      <span title={"tempo da pausa em minutos"} style={{ fontSize: '18px', color: '#8891A7' }}>
        {duration} min
      </span>
    </div>
  );
};
